import { useRef, useState, useCallback } from 'react';

interface UseScrollFadeReturn {
  scrollRef: React.RefObject<HTMLDivElement | null>;
  isAtTop: boolean;
  isAtBottom: boolean;
  handleScroll: () => void;
}

const useScrollFade = (): UseScrollFadeReturn => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isAtTop, setIsAtTop] = useState(true);
  const [isAtBottom, setIsAtBottom] = useState(false);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setIsAtTop(el.scrollTop <= 2);
    setIsAtBottom(el.scrollHeight - el.scrollTop <= el.clientHeight + 2);
  }, []);

  return { scrollRef, isAtTop, isAtBottom, handleScroll };
};

export default useScrollFade;
